var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#242A2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0984 6H24L17.9615 11.5055C15.7747 13.4982 12.2292 13.4982 10.0409 11.5055L4 6H6.90397L11.4917 10.1822C12.1601 10.7888 13.0609 11.1289 13.9994 11.1289C14.9379 11.1289 15.8387 10.7888 16.5072 10.1822L21.0984 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89258 22H4L10.0547 16.4873C12.2332 14.5042 15.7652 14.5042 17.9453 16.4873L24 22H21.1094L16.5 17.8042C15.8341 17.2005 14.9367 16.8621 14.0018 16.8621C13.0668 16.8621 12.1694 17.2005 11.5035 17.8042L6.89258 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyXrp);
export default __webpack_public_path__ + "static/media/Currency=XRP.27a84706027aae59b670458299bb18f6.svg";
export { ForwardRef as ReactComponent };